import { render, staticRenderFns } from "./weekCourseModel.vue?vue&type=template&id=66d3e922&scoped=true"
import script from "./weekCourseModel.vue?vue&type=script&lang=js"
export * from "./weekCourseModel.vue?vue&type=script&lang=js"
import style0 from "./weekCourseModel.vue?vue&type=style&index=0&id=66d3e922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d3e922",
  null
  
)

export default component.exports